import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import styled from "styled-components";
import { Typography, Button } from "@material-ui/core";
import ActionCreator from './../../../store/actions/index';

const CookieInfoWrapper = styled.div`
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translate(-50%, 0);
    margin: auto;
    width: 80%;
    background: rgba(105, 108, 113, 0.8);
    padding: 10px 20px 10px 20px;
    border-radius: 10px;
    z-index: 5000;
    color: #FFF;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const CookieInfoBar = ({visible, changeCookieAcceptation}) => {
    return (
        <>
            {
                visible &&
                <CookieInfoWrapper>
                    <Typography variant="body2">
                        Uwaga! System automatycznie wyloguje użytkownika po jednej godzinie bezczynności.
                        Nasz serwis wykorzystuje pliki cookies do przechowywania własnego identyfikatora i danych usprawniających korzystanie z panelu.
                        Logując się do systemu wyrażasz zgodę na wykorzystanie plików cookies.
                        Możesz zrezygnować z korzystania z plików cookies, zmieniając ustawienia Twojej przeglądarki,
                        niemniej w takim przypadku nie gwarantujemy poprawnego działania serwisu.
                    </Typography>
                    <Button
                        variant="outlined"
                        style={{color: "#FFF"}}
                        onClick={() => changeCookieAcceptation(true)}
                    >
                        OK
                    </Button>
                </CookieInfoWrapper>
            }
        </>
    );
};

const mapStateToProps = (state) => ({
    visible: !state.requestReducer.cookiesAccepted
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


CookieInfoBar.propTypes = {
    //redux
    visible: PropTypes.bool,
    changeCookieAcceptation: PropTypes.func
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CookieInfoBar);
